import { useCallback } from 'react';
import { useHistory, useLocation } from 'react-router';

import { routes } from 'client/lib/routes';
import { Channel } from 'client/model/skill';

export const useIsDraft = (channel: Channel, installableAppId = '') => {
    const { pathname } = useLocation();
    const history = useHistory();
    const isDraft = (pathname || '').startsWith(routes.app.installableAppSettings(channel, true, '', installableAppId));
    const setIsDraft = useCallback(
        (isDraftUpdated: boolean, channel: Channel) => {
            history.push(`${routes.app.appPage(channel, isDraftUpdated, 'settings', installableAppId)}/main`);
        },
        [installableAppId, history],
    );
    return { isDraft, setIsDraft };
};

export const useSkillIsDraft = (skillId = '') => {
    const { pathname = '' } = useLocation();
    const history = useHistory();
    const isDraft = pathname.startsWith(routes.app.skillPage(true, '', skillId));
    const setIsDraft = useCallback(
        (isDraftUpdated: boolean) => {
            history.push(
                pathname.replace(
                    routes.app.skillPage(!isDraftUpdated, '', skillId),
                    routes.app.skillPage(isDraftUpdated, '', skillId),
                ),
            );
        },
        [skillId, history, pathname],
    );
    return { isDraft, setIsDraft };
};
